import { render, staticRenderFns } from "./UserNewForm.vue?vue&type=template&id=46828680"
import script from "./UserNewForm.vue?vue&type=script&lang=js"
export * from "./UserNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports